var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinFront(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 127,
    viewBox: "0 0 117 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 108L112 54.5L58.5 1L5 54.5L58.5 108Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 61.0644L58.5 114.564L112 61.0644V54.5L58.5 108L5 54.5V61.0644Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 54.5V61.0644L58.5 114.564L112 61.0644V54.5M5 54.5L58.5 108L112 54.5M5 54.5L58.5 1L112 54.5",
    stroke: "#1293D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 114.564C79.393 93.6714 112 61.0644 112 61.0644V54.5517L58.5 108V111.282C58.5 111.282 58.5 113.283 58.5 114.564Z",
    fill: "#1293D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 108L5 54.5V61.0644C25.893 81.9575 37.607 93.6714 58.5 114.564C58.5 113.283 58.5 111.282 58.5 111.282V108Z",
    fill: "#094B6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3391 71H77V57.4434C77 50.7883 75.5678 45.672 67.8028 45.672C66.3458 45.6178 64.9014 45.9603 63.6235 46.6633C62.3455 47.3662 61.2818 48.4032 60.5456 49.6637H60.4465V46.286H53.0921V70.999H60.7529V58.7687C60.7529 55.5449 61.3639 52.4225 65.354 52.4225C69.2876 52.4225 69.3391 56.1132 69.3391 58.9793V71Z",
    fill: "#1293D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9768 42.1572C42.7081 42.6464 43.5679 42.9075 44.4473 42.9073C45.6264 42.907 46.7571 42.4377 47.5907 41.6025C48.4244 40.7673 48.8927 39.6346 48.8927 38.4536C48.8927 37.5727 48.6319 36.7116 48.1433 35.9792C47.6547 35.2468 46.9602 34.676 46.1477 34.3389C45.3351 34.0019 44.4411 33.9137 43.5785 34.0856C42.716 34.2576 41.9238 34.6818 41.302 35.3048C40.6802 35.9277 40.2568 36.7214 40.0853 37.5854C39.9139 38.4494 40.0021 39.3449 40.3387 40.1586C40.6754 40.9724 41.2455 41.6679 41.9768 42.1572Z",
    fill: "#1293D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.609 70.999H48.2778L48.2788 46.286H40.609V70.999Z",
    fill: "#1293D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinFront);
export default __webpack_public_path__ + "static/media/linkedin-front.9be5921b2e71520dcffa253bf2488bad.svg";
export { ForwardRef as ReactComponent };